import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CrudService, CrudType, IApplicationResponse,ModulesBasedApiSuffix, onActionSubmittedUtil, OtherService, PERMISSION_RESTRICTION_ERROR, prepareGetRequestHttpParams, prepareRequiredHttpParams, ResponseMessageTypes, RxjsService, SnackbarService, UserService } from '@app/shared';
import { CallEscalationDialogComponent } from '@modules/customer/components/customer/technician-installation/call-escalation-dialog';
import { DealerTaskRequestType } from '@modules/dealer';
import { DealerModuleApiSuffixModels } from '@modules/dealer/shared/enum/dealer.enum';
import { MY_TASK_COMPONENTS } from '@modules/my-tasks/shared/utils/task-list.enum';
import { TechnicalMgntModuleApiSuffixModels } from '@modules/technical-management/shared/enum.ts/technical.enum';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { map } from 'rxjs/operators';
import { PrimeNgTableVariablesModel } from '../../../../shared/models/prime-ng-table-list-component-variables.model';
import { TechPaymentMethodDialogComponent } from '@modules/technical-management/components/technical-area-manager-worklist/tech-payment-method-dialog/tech-payment-method-dialog.component';
import { BillingModuleApiSuffixModels } from '@modules/sales/shared/utils/billing-module.enum';
import { DealerCustomerComponent } from '@modules/technical-management/components/technical-area-manager-worklist/dealer-customer/dealer-customer.component';
import { MatDialog } from '@angular/material';
import { handleNgrxStoreData, processStoreData } from '@app/shared/utils/combine-page-level.utils';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-dealer-worklist',
  templateUrl: './dealer-worklist.component.html'
})
export class DealerWorklistComponent extends PrimeNgTableVariablesModel implements OnInit {

  dateFormat = 'MMM dd, yyyy';
  primengTableConfigProperties: any;
  row: any = {};
  listSubscription: any;
  first: any = 0;
  filterData: any;
  permission = []
  paymentMethodSubscritption: any // to handle subscription for forkJoin
  callEscalationsubscritption;
  constructor(
    private crudService: CrudService,
    private router: Router,
    private snackbarService: SnackbarService,
    private rxjsService: RxjsService,
    private store: Store<AppState>, private userService: UserService,
    private dialogService: DialogService, private otherService: OtherService, private dialog: MatDialog,) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: "Dealer Task List",
      breadCrumbItems: [{ displayName: 'My Task', relativeRouterUrl: '' }, { displayName: 'Dealer Task List' }],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Dealer Task List',
            dataKey: 'referenceId',
            captionFontSize: '21px',
            enableBreadCrumb: true,
            enableAction: true,
            enableScrollable: true,
            enableFieldsSearch: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'requestNumber', header: 'Request Number', width: '150px' },
              { field: 'reference', header: 'Reference', width: '100px' },
              { field: 'dealerIIPCode', header: 'Dealer Code', width: '120px', isLink: true },
              { field: 'companyName', header: 'Dealer Name', width: '150px' },
              { field: 'dealerTypeName', header: 'Dealer Type', width: '150px' },
              { field: 'customerRefNo', header: 'Customer ID', width: '120px' },
              { field: 'debtorCode', header: 'Debtors Code', width: '150px' },
              { field: 'customerName', header: 'Customer Desc', width: '150px' },
              { field: 'requestTypeName', header: 'Request Type', width: '120px' },
              { field: 'requestMotivationName', header: 'Request Motivation', width: '200px' },
              { field: 'value', header: 'Value', width: '80px' },
              { field: 'notes', header: 'Reason', width: '120px' },
              { field: 'dueDate', header: 'Due Date', width: '160px', isDateTime:true  },
              { field: 'createdDate', header: 'Creation Date', width: '160px', isDateTime:true  },
              { field: 'createdBy', header: 'Created By', width: '130px' },
              { field: 'creatorRole', header: 'Creators Role', width: '130px' },
              { field: 'divisionName', header: 'Division', width: '100px' },
              { field: 'districtName', header: 'District', width: '100px' },
              { field: 'branchName', header: 'Branch', width: '100px' },
              { field: 'subArea', header: 'Sub Area', width: '100px' },
              { field: 'techArea', header: 'Tech Area', width: '100px' },
              { field: 'salesArea', header: 'Sales Area', width: '100px' },
              { field: 'fullAddress', header: 'Address', width: '150px' },
              { field: 'currentApprovalLevel', header: 'Current Approval Level', width: '200px' },
              { field: 'lastApprovedBY', header: 'Last Approval Done By', width: '200px' },
              { field: 'lastApprovedDate', header: 'Last Approval Date/Time', width: '200px', isDateTime:true  },
              { field: 'isEscalated', header: 'Escalated', width: '100px' },
              { field: 'actionedDate', header: 'Actioned Date', width: '160px', isDateTime:true },
              { field: 'status', header: 'Status', width: '80px' },
            ],
            isDateWithTimeRequired: true,
            apiSuffixModel: DealerModuleApiSuffixModels.DEALER_TASK_LIST,
            moduleName: ModulesBasedApiSuffix.DEALER,
          }
        ]
      }
    }
  }

  ngOnInit(): void {
    handleNgrxStoreData((response) => {
      let processData = processStoreData(response, this.primengTableConfigProperties, MY_TASK_COMPONENTS.DEALER);
      this.primengTableConfigProperties = processData.primengTableConfigProperties
      this.loggedInUserData = processData.loggedInUserData
    }, this.store);
    this.onCRUDRequested('get');
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  getTableListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    let dealerModuleApiSuffixModels: DealerModuleApiSuffixModels;
    dealerModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    if (this.listSubscription && !this.listSubscription.closed) {
      this.listSubscription.unsubscribe();
      this.rxjsService.setGlobalLoaderProperty(false);
    }
    this.listSubscription = this.crudService.get(
      this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].moduleName,
      dealerModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).pipe(map((res: IApplicationResponse) => {
      if (res?.resources) {
        res?.resources?.forEach(val => {
          val.requestId = val?.taskListId ? val?.taskListId : '';
          return val;
        })
      }
      return res;
    })).subscribe((data: IApplicationResponse) => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.dataList = data.resources;
        this.totalRecords = data.totalCount;
      } else {
        this.dataList = null;
        this.totalRecords = 0;
      }
    })
  }

  onCRUDRequested(type: CrudType | string, row?: object | any, unknownVar?: any): void {
    switch (type) {
      case CrudType.CREATE:
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        this.row = row ? row : { pageIndex: 0, pageSize: 10 };
        this.first = row?.pageIndex && row?.pageSize ? row["pageIndex"] * row["pageSize"] : 0;
        unknownVar = { ...this.filterData, ...unknownVar, IsAll: true, userId: this.loggedInUserData?.userId };
        this.getTableListData(this.row["pageIndex"], this.row["pageSize"], unknownVar);
        break;
      case CrudType.EDIT:
        this.openAddEditPage(CrudType.EDIT, row, unknownVar);
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.VIEW, row);
        break;

      default:
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string | any, unknownVar?: any): void {
    switch (type) {
      case CrudType.VIEW:
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canApprove) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        if (editableObject['requestTypeName'] == DealerTaskRequestType.DEALER_APPROVAL) {
          this.onOpenDealerApproval(editableObject);
        } else if (editableObject['requestTypeName'] == DealerTaskRequestType.DEALER_INSPECTION_FORM) {
          this.openInspectionFormApprovalPage(editableObject);
        } else if (editableObject['requestTypeName'] == DealerTaskRequestType.DEALER_CALL_ESCALATION) {
          this.openCallEscalationDialog(editableObject);
        } else if (editableObject['requestTypeName'].toLowerCase() == DealerTaskRequestType.PAYMENT_METHOD) {
          this.openPaymentMethod(editableObject);
        } else if (DealerTaskRequestType.DEALER_CUSTOMER_VERIFICATION == editableObject['requestTypeName'].toLowerCase()) {
          this.openDealerCustomerVerfication(editableObject);

        } else if (DealerTaskRequestType.DEALER_CUSTOMER == editableObject['requestTypeName'].toLowerCase()) {
          this.openDealerCustomerDialog(editableObject);
        }
        break;
      case CrudType.EDIT:
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        if (editableObject['requestTypeName'] == DealerTaskRequestType.DEALER_APPROVAL && unknownVar == 'dealerIIPCode') {
          window.open(`/dealer/dealer-maintenance/info/view?id=${editableObject?.dealerId}&dealerTypeId=${editableObject?.dealerTypeId}`);
          // this.router.navigate(['/dealer/dealer-maintenance/info/view'], { queryParams: { tab: 0, id: editableObject?.dealerId, dealerTypeId: editableObject?.dealerTypeId, }, skipLocationChange: false })
        } else if ((editableObject['requestTypeName'] == DealerTaskRequestType.DEALER_CALL_ESCALATION || editableObject['requestTypeName'] == DealerTaskRequestType.DEALER_INSPECTION_FORM) && unknownVar == 'reference') {
          window.open(`${window.location.origin}/customer/manage-customers/inspection-call?customerInspectionId=${editableObject['callInitiationId']}&customerId=${editableObject['customerId']}&customerAddressId=${editableObject.addressId}&requestId=${editableObject.requestId}&isNew='taskmanagerlist'&isDealer=true`);
        } else if (editableObject['requestTypeName'].toLowerCase() == DealerTaskRequestType.PAYMENT_METHOD && unknownVar == 'dealerIIPCode') {
          // this.openPaymentMethod(editableObject);
          window.open(`/dealer/dealer-maintenance/info/view?id=${editableObject?.dealerId}&dealerTypeId=${editableObject?.dealerTypeId}`);
        } else if (DealerTaskRequestType.DEALER_CUSTOMER_VERIFICATION == editableObject['requestTypeName'].toLowerCase()) {
          this.openDealerCustomerVerfication(editableObject);

        } else if (DealerTaskRequestType.DEALER_CUSTOMER == editableObject['requestTypeName'].toLowerCase()) {
          this.openDealerCustomerDialog(editableObject);
        }
        break;
    }
  }

  openDealerCustomerVerfication(row) {
    // let route = ['/technical-management', 'technical-area-manager-worklist'];
    // if (this.isMyTask) {
    let route = ['/my-tasks', 'task-list'];
    // }
    this.router.navigate([route[0], route[1], 'due-diligence-customer-verification'], {
      queryParams: { addressId: row['addressId'], customerId: row['customerId'] ,fromComponent:'dealer', allowEdit:row['allowEdit']}, skipLocationChange: false
    });
  }


  /* --- Open Dealer Customer Dialog ---- */
  openDealerCustomerDialog(row: any) {
    if (row.status?.toLowerCase() == 'declined') {
      // this.snackbarService.openSnackbar("Request is declined already we cannot edit.", ResponseMessageTypes.WARNING);
      this.router.navigate([`/dealer/dealer-contract/add-edit`],{queryParams:{customerId: row?.customerId, addressId : row.addressId}})
      return;
    }
    this.rxjsService.setGlobalLoaderProperty(true);
    if (this.callEscalationsubscritption && !this.callEscalationsubscritption.closed) {
      this.callEscalationsubscritption.unsubscribe();
    }
    this.callEscalationsubscritption = this.crudService.get(ModulesBasedApiSuffix.DEALER,
      DealerModuleApiSuffixModels.DEALER_CUSTOMER_APPROVAL_DETAILS, null, false, prepareRequiredHttpParams({
        customerId: row.customerId,
        addressId: row.addressId
      })).subscribe((res: any) => {
        this.rxjsService.setGlobalLoaderProperty(false);
        if (res?.isSuccess == true && res?.statusCode == 200 && res?.resources) {
          res.resources.dealerCustomerCheckListObject = {
            isExpanded: false,
            isCollapsed: true,
            areMandatoryFilled: false,
            categoryName: 'Checklist',
            dealerCustomerCheckList: res.resources?.dealerCustomerCheckList
          };
          const ref = this.dialog.open(DealerCustomerComponent, {
            width: '830px',
            data: {
              header: 'Contract Purchase',
              createdUserId: this.loggedInUserData?.userId,
              row: row,
              contractPurchaseObject: res?.resources,
            },
          });
          ref.afterClosed().subscribe((res) => {
            if (res) {
              this.router.navigate(['/customer/manage-customers']);
              // this.onCRUDRequested('get');
            }
          });
        }
      });
  }
  /* --- Close Dealer Customer Dialog ---- */


  openPaymentMethod(row) {
    const api = [
      this.crudService.dropdown(ModulesBasedApiSuffix.BILLING, BillingModuleApiSuffixModels.UX_PAYMENT_METHODS,
        prepareRequiredHttpParams({ isCustomerBilling: false, isDealerBilling: true })),
      this.crudService.get(ModulesBasedApiSuffix.BILLING, BillingModuleApiSuffixModels.DEALER_INVOICE_PAYMENT_METHOD, row['referenceId']),

    ]
    this.rxjsService.setGlobalLoaderProperty(true);
    if (this.paymentMethodSubscritption && !this.paymentMethodSubscritption.closed) {
      this.paymentMethodSubscritption.unsubscribe();
    }
    let paymentMethodList = [];
    forkJoin(api).subscribe((res: IApplicationResponse[]) => {
      this.rxjsService.setGlobalLoaderProperty(false);
      res?.forEach((resp: IApplicationResponse, ix: number) => {
        if (resp?.isSuccess == true && resp?.statusCode == 200 && resp?.resources) {
          switch (ix) {
            case 0:
              paymentMethodList = resp?.resources
              break;
            case 1:
              const data = {
                paymentMethodList: paymentMethodList,
                invoiceId: resp?.resources?.invoiceId,
                row: {
                  invoiceId: resp?.resources?.invoiceId,
                  paymentMethodId: resp?.resources?.paymentMethodId ? resp?.resources?.paymentMethodId : '',
                  debitDate: resp?.resources?.debitDate ? new Date(resp?.resources?.debitDate) : null,
                  modifiedUserId: this.loggedInUserData?.userId,
                },
                viewPaymentDetail: [
                  { name: 'Invoice Number', value: resp?.resources?.invoiceRefNo },
                  { name: 'Dealer Name', value: resp?.resources?.dealerName },
                  { name: 'Dealer Code', value: resp?.resources?.dealerIIPCode },
                  { name: 'Invoice Amount', value: resp?.resources?.totalAmount, isRandSymbolRequired:true },
                  // { name: 'Invoice Amount', value: resp?.resources?.totalAmount ? this.otherService.transformDecimal(resp?.resources?.totalAmount) : '' },
                  { name: 'Dealer Branch Code', value: resp?.resources?.dealerBranchCode },
                  { name: 'Invoice Created Date', value: resp?.resources?.createdDate },
                  { name: 'Stock Order Number', value: resp?.resources?.stockOrderNumber },
                ],
              };
              this.openPaymentMethodDialog(data);
              break;
          }
        }
      });
    });
  }

  openPaymentMethodDialog(data) {
    const ref = this.dialogService.open(TechPaymentMethodDialogComponent, {
      header: 'Invoice Details',
      baseZIndex: 1000,
      width: '60vw',
      closable: false,
      showHeader: false,
      data: data
    });
    this.userService.openedPrimeDialog.push(ref);
    ref.onClose.subscribe((res) => {
      if (res) {
        this.onCRUDRequested('get');
      }
      this.userService.openedPrimeDialog = [];
    });
  }


  onOpenDealerApproval(row) {
    if (row?.currentLevel == 0 || row?.currentLevel == null && row?.requestTypeName.toLowerCase() == 'dealer approval') {
      this.router.navigate(['/dealer/dealer-maintenance'], { queryParams: { tab: 4, id: row?.dealerId, dealerTypeId: row?.dealerTypeId }, skipLocationChange: false })
    }
    else {
      if (row['status']?.toLowerCase() == 'pending' || row['status']?.toLowerCase() == 'resubmit') {
        this.router.navigate(['/dealer/dealer-maintenance'], { queryParams: { tab: 4, id: row?.dealerId, dealerTypeId: row?.dealerTypeId, referenceId: row?.referenceId, }, skipLocationChange: false })
      } else if (row['status']?.toLowerCase() == 'declined') {
        this.snackbarService.openSnackbar(`This request needs to be resubmit the previous level`, ResponseMessageTypes.WARNING);
      } else {
        this.snackbarService.openSnackbar(`This request is already ${row['status']?.toLowerCase()}. So please try any other requests`, ResponseMessageTypes.WARNING);
      }
    }
  }

  openInspectionFormApprovalPage(row) {
    this.router.navigate(['/technical-management', 'inspection-call', 'inspection-form-add-edit'], {
      queryParams: {
        CustomerInspectionId: row['callInitiationId'],
        CustomerId: row['customerId'],
        AddressId: row['addressId'],
        requestId: row['taskListId'],
        referenceId: row['referenceId'],
        isDealer: true,
        isNew: 'taskmanagerlist'
      }
    });
  }

  /* --- Open Call Escalation Dialog ---- */
  openCallEscalationDialog(row?) {
    this.rxjsService.setGlobalLoaderProperty(true);
    this.crudService.get(ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.QUICK_CALL_ESCALATION, null, false, prepareRequiredHttpParams({ CallInitiationEscalationApprovalId: row['referenceId'] })).subscribe((res: any) => {
        this.rxjsService.setGlobalLoaderProperty(false);
        if (res?.isSuccess == true && res?.statusCode == 200 && res?.resources) {
          const ref = this.dialogService.open(CallEscalationDialogComponent, {
            header: 'Service Call Escalation',
            baseZIndex: 1000,
            width: '400px',
            // closable: false,
            showHeader: false,
            data: {
              header: 'Dealer Call Escalation',
              ...res?.resources,
              createdUserId: this.loggedInUserData?.userId,
              isServiceCallEscalation: true,
              row: row,
            },
          });
          this.userService.openedPrimeDialog.push(ref);
          ref.onClose.subscribe((res) => {
            if (res) {
              this.onCRUDRequested('get');
            }
            this.userService.openedPrimeDialog = [];
          });
        }
      });
  }
  /* --- Close Call Escalation Dialog ---- */


  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }

  getPermissionByActionType(actionTypeMenuName): boolean {
    let foundObj = this.permission['subMenu'].find(fSC => fSC.menuName == actionTypeMenuName);
    if (foundObj) {
      return false;
    }
    else {
      return true;
    }
  }

  ngOnDestroy() {

    if (this.listSubscription) {
      this.listSubscription.unsubscribe();
    }

    if (this.paymentMethodSubscritption) {
      this.paymentMethodSubscritption.unsubscribe();
    }
  }
}
